import type { ErrorMessages } from '@repo/types/messages/errors';

import { ErrorCodes } from '#errorCodes';

import { baseErrorMessages } from './baseErrorMessages';

export const quizErrorMessages: ErrorMessages = {
  ...baseErrorMessages,
  403: {
    title: 'Brak uprawnień',
    detail: 'Tylko uczeń może uruchomić quiz',
  },
  419: {
    title: 'Niedostępne',
    detail: 'Quiz jest poza okienkiem dostępności czasowej',
  },
  409: {
    title: 'Konflikt',
    detail: 'Quiz został już gdzieś uruchomiony',
  },
  [ErrorCodes.FORBIDDEN.QUIZ.OUTSIDE_AVAILBILITY]: {
    title: 'Quiz poza dostępnością',
    detail: 'Quiz jest dostępny tylko w określonym czasie. Spróbuj ponownie później.',
  },
  [ErrorCodes.FORBIDDEN.QUIZ.START_ONLY_USER]: {
    title: 'Brak uprawnień',
    detail: 'Tylko uczeń może rozpocząć quiz',
  },
  [ErrorCodes.FORBIDDEN.QUIZ.ATTEMPT_ONGOING]: {
    title: 'Quiz już rozpoczęty',
    detail: 'Ten quiz został już rozpoczęty w innej sesji. Czy chcesz wymusić nowy start? Spowoduje to zakończenie poprzedniej sesji.',
  },
  [ErrorCodes.FORBIDDEN.QUIZ.ATTEMPT_ONGOING_OTHER_QUIZ]: {
    title: 'Masz niezakończony inny quiz',
    detail: 'Najpierw zakończ rozpoczętą próbę innego quizu. Możesz też wymusić start tego quizu — spowoduje to zakończenie tamtej próby.',
  },
  [ErrorCodes.FORBIDDEN.QUIZ.EXCEEDED_MAX_ATTEMPTS]: {
    title: 'Przekroczono maksymalną liczbę prób',
    detail: 'Nie możesz rozpocząć więcej prób tego quizu.',
  },
  [ErrorCodes.FORBIDDEN.QUIZ.NO_VALID_ATTEMPT]: {
    title: 'Brak ważnej próby',
    detail: 'Nie masz żadnej ważnej próby tego quizu.',
  },
  [ErrorCodes.NOT_FOUND.QUIZ_ATTEMPT]: {
    title: 'Próba nie znaleziona',
    detail: 'Nie znaleziono próby tego quizu.',
  },
  [ErrorCodes.FORBIDDEN.QUIZ.ALREADY_COMPLETED]: {
    title: 'Quiz już ukończony',
    detail: 'Ten quiz został już ukończony.',
  },
  [ErrorCodes.FORBIDDEN.QUIZ.NO_INSTANT_MARK]: {
    title: 'Brak natychmiastowego oznaczania',
    detail: 'Ten quiz nie obsługuje natychmiastowego oznaczania.',
  },
  [ErrorCodes.FORBIDDEN.QUIZ.SECTION_MARKED]: {
    title: 'Sekcja już oznaczona',
    detail: 'Ta sekcja została już oznaczona jako sprawdzona.',
  },
  [ErrorCodes.FORBIDDEN.QUIZ.ANSWER_INVALIDATION]: {
    title: 'Usunięcie quizu',
    detail: 'Istnieją zarejestrowane próby tego quizu. Usunięcie quizu spowoduje również usunięcie tych prób.',
  },
  [ErrorCodes.FORBIDDEN.QUIZ.NOT_COMPLETED]: {
    title: 'Quiz nieukończony',
    detail: 'Ta próba nie została jeszcze ukończona.',
  },
};
